import { AiFillVideoCamera, AiOutlineFile, AiOutlineFileAdd } from "react-icons/ai";
import { MdOutlineInsertPageBreak, MdOutlineNewspaper, MdOutlineSync, MdOutlineVideoCall } from "react-icons/md";

//Page / Card Title: SharePoint / OneDrive
export const sharepointData = [
  {
    title: "Embedding Documents on WordPress Pages & Posts",
    video: true,
    videoId: "fZnU3e4vEgs",
    videoType: "youtube",
    icon: <AiOutlineFileAdd className='text-white fs-5' />
  },
  {
    title: "SharePoint News & Article Sync Video",
    video: true,
    videoId: "uw4hXO9oL4E",
    videoType: "youtube",
    icon: <MdOutlineNewspaper className='text-white fs-5' />
  },
  {
    title: "Streamlining Document Syncing: From SharePoint to WordPress",
    video: true,
    videoId: "job-sgfC7Jg",
    videoType: "youtube",
    icon: <MdOutlineSync className='text-white fs-5' />
  },
  {
    title: "Display SharePoint’s Custom Column on a WordPress Page or Post",
    video: true,
    videoId: "_M0B0nyqxfw",
    videoType: "youtube",
    icon: <MdOutlineInsertPageBreak className='text-white fs-5' />
  },
  {
    title: "Stream SharePoint videos on WordPress / LMS Integration",
    video: true,
    videoId: "Du3reFZoy78",
    videoType: "youtube",
    icon: <MdOutlineVideoCall className='text-white fs-5' />
  }
]